import React from 'react';
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip, LabelList, Legend, CartesianGrid } from 'recharts';
import { Colors } from '../../../constants/Colors.js';

const AvancesSICCoop = ({ dataGraficaMunicipios, dataCuentas }) => {
  const valueAccessor = attribute => ({ payload }) => {
    let value = payload[attribute];
    if (value > 0) {
      if (value > 5) {
        return value;
      } else {
        return '';
      }
    } else {
      return '';
    }
  };

  return (
    <>
      {/* header title for total sic levantamiento */}
      <div className="row">
        <div className="col-12">
          <h6 className="font-lato-normal-400 heading-box">Avance total de levantamiento (SIC)</h6>
        </div>
      </div>
      <ResponsiveContainer width="104%" height={120} className="barchart-horizontal-margin">
        <BarChart
          layout="vertical"
          data={[
            {
              name: 'Totales',
              total_levantado: dataGraficaMunicipios.reduce((acc, current) => +acc + +current.total_levantado, 0),
              total_pendiente: dataGraficaMunicipios.reduce((acc, current) => +acc + +current.total_pendiente, 0),
            },
          ]}>
          <XAxis type="number" stroke="#666" axisLine={false} tickLine={false} tick={false} label={'Total de productores'} />
          <YAxis dataKey="name" type="category" stroke="#666" axisLine={false} tickLine={false} tick={false} />
          <Tooltip />
          <Legend />
          <Bar name="Realizado" radius={[5, 0, 0, 5]} dataKey="total_levantado" stackId="a" fill={'#C7AE34'}>
            <LabelList
              style={{
                textAnchor: 'middle',
                fontSize: '14',
                fill: Colors.white,
              }}
              valueAccessor={valueAccessor('total_levantado')}
            />
          </Bar>
          <Bar name="Pendiente" radius={[0, 5, 5, 0]} dataKey="total_pendiente" stackId="a" fill={Colors.black_medium}>
            <LabelList
              style={{
                textAnchor: 'middle',
                fontSize: '14',
                fill: Colors.neutral_2,
              }}
              valueAccessor={valueAccessor('total_pendiente')}
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
      <div className="font-lato-normal-400 text-right pr-4" style={{ fontSize: 18 }}>
        Total de productores en Padrón (SIC):{' '}
        <a href="/admin/cuentas/list?organico=1" className="font-forum-normal-400">
          <span className="nv-pie-title">{dataGraficaMunicipios.reduce((acc, current) => +acc + +current.total_esperado, 0)}</span>
        </a>
      </div>
      <div className="font-lato-normal-400 text-right pr-4" style={{ fontSize: 18 }}>
        Total de productores en la organización:{' '}
        <a href="/admin/cuentas/list" className="font-forum-normal-400">
          <span className="nv-pie-title">{dataCuentas.length}</span>
        </a>
      </div>
    </>
  );
};

export default AvancesSICCoop;
